export default "__VITE_ASSET__BnOby44C__"